import React, { useContext as useContextCore } from 'react'
import { components as defaultComponents } from './components'
import merge from 'lodash/merge'
import first from 'lodash/first'
import map from 'lodash/map'
import { TabName } from './TabName'
import { useError } from '@ztechapps/common.hook'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, components, onAddTask, error, loading, onCancel, shownTabs, ...props }: any) => {
  shownTabs = shownTabs ?? map(TabName, (e) => e)
  const firstTab = first(shownTabs)
  const [activeTab, setActiveTab] = React.useState(firstTab)
  const [newTasks, setNewTasks] = React.useState([])

  //merge the injectable components
  components = merge({}, defaultComponents, components)
  useError(error)

  return (
    <CoreProvider
      value={{
        ...props,
        components,
        activeTab,
        onCancel,
        setActiveTab,
        newTasks,
        setNewTasks,
        shownTabs,
        addTask: { action: onAddTask, loading, error },
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
